import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarResponsavelTecnicoDs,
} from "../../DataSources";
import { Button } from "devextreme-react";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  nome: "",
  cpf: "",
  cnpj: "",
  crea: "",
  rg: "",
  cep: "",
  ruaEndereco: "",
  numeroEndereco: "",
  complemento: "",
  bairro: "",
  cidade: "",
  uf: "",
  telefone: "",
};

export default class ResponsavelTecnicoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.responsavelTecnicoDs = criarResponsavelTecnicoDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.responsavelTecnicoDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Responsável técnico não encontrado.", "error");
              this.props.history.push("/responsaveistecnicos");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="DADOS DO RESPONSÁVEL TÉCNICO"
              colSpan={2}
              colCount={3}
            >
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Nome" />
              </SimpleItem>
              <SimpleItem
                dataField={"cpf"}
                colSpan={1}
                editorOptions={{ mask: "000.000.000-00" }}
              >
                <Label text="CPF" />
              </SimpleItem>
              <SimpleItem
                dataField={"cnpj"}
                colSpan={1}
                editorOptions={{ mask: "00.000.000/0000-00" }}
              >
                <Label text="CNPJ" />
              </SimpleItem>
              <SimpleItem dataField={"crea"} colSpan={1}>
                <Label text="CREA" />
              </SimpleItem>
              <SimpleItem dataField={"rg"} colSpan={1}>
                <Label text="RG" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="ENDEREÇO E CONTATO" colSpan={2} colCount={8}>
              <SimpleItem
                dataField={"cep"}
                colSpan={2}
                editorOptions={{ mask: "00000-000" }}
              >
                <Label text="CEP" />
              </SimpleItem>
              <SimpleItem dataField={"ruaEndereco"} colSpan={5}>
                <Label text="Rua" />
              </SimpleItem>
              <SimpleItem dataField={"numeroEndereco"} colSpan={1}>
                <Label text="Nº" />
              </SimpleItem>
              <SimpleItem dataField={"complemento"} colSpan={4}>
                <Label text="Complemento" />
              </SimpleItem>
              <SimpleItem dataField={"bairro"} colSpan={2}>
                <Label text="Bairro" />
              </SimpleItem>
              <SimpleItem dataField={"cidade"} colSpan={2}>
                <Label text="Cidade" />
              </SimpleItem>
              <SimpleItem dataField={"uf"} colSpan={1}>
                <Label text="UF" />
              </SimpleItem>
              <SimpleItem dataField={"telefone"} colSpan={2}>
                <Label text="Telefone" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                width={120}
                text="Cancelar"
                type="warn"
                onClick={this.cancel}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.responsavelTecnicoDs, entidade)
      .then(
        function () {
          notify("Responsável técnico cadastrada com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
